import React from 'react';
import PropTypes from 'prop-types';
import { Card as SashCard, List } from '@pella/sash-framework';
import { classNames } from '@pella/sash-framework/dist/utilities';
import { CTA } from '../../';
import StoreInfo from '../store-info';

const Card = ({ data }) => {
	const classes = classNames({
		'pal-card !border-0 hover:!shadow-lg': true,
	});

	return (
		<SashCard
			className={classes}
			variant={data.variant}
			horizontal={data.horizontal}
		>
			{data?.image?.[0] && (
				<SashCard.Image
					{...data.image[0].file?.gatsbyImageData?.images?.fallback}
					objectFit={data.image[0].contain ? 'scale-down' : ''}
				/>
			)}
			{data?.heading && <SashCard.Heading content={data.heading} />}
			{data?.subheading && <div dangerouslySetInnerHTML={{ __html: data.subheading }} />}

			<SashCard.Content
				content={data.description}
				className={`[&_ul]:space-y-2 ${data.variant === 'award' ? '!mt-0' : ''}`}
			>
				{data.add_location && <StoreInfo />}

				{data.horizontal && data.cta?.[0] && (
					<List
						bullets='none'
						className='mt-4 !space-y-1'
					>
						{data.cta.map((cta, index) => (
							<li
								key={index}
								className='text-sm md:text-base'
							>
								<CTA
									data={cta}
									renderAs='link'
									className='no-underline !decoration-current hover:underline'
								/>
							</li>
						))}
					</List>
				)}
			</SashCard.Content>

			{data?.cta?.[0] && !data.horizontal && (
				<List
					bullets='none'
					className={`mt-auto space-y-1.5 ${data.variant === 'standard-padded-content' ? 'px-4 pb-4' : 'pt-4'}`}
				>
					{data.cta.map((cta, index) => (
						<li key={index}>
							<CTA
								data={cta}
								size={cta.button_style !== 'tertiary' ? 'sm' : null}
								wide={cta.button_style !== 'tertiary' ? true : null}
							/>
						</li>
					))}
				</List>
			)}
		</SashCard>
	);
};

Card.propTypes = {
	data: PropTypes.object.isRequired,
};

export default Card;
